<template>
  <div
    v-test="'service-variation-resources'"
    :class="$style.base"
  >
    <BaseToggle
      v-if="activeVariations.length > 1"
      v-model="requirementsPerVariation"
      :label="$t('service.resources.different_per_variation_toggle')"
      v-test="'requirements-per-variation-toggle'"
    />
    <BaseText
      v-if="requirementsPerVariation"
      inline
    >
      {{ $t('service.resources.different_per_variation_info') }}
    </BaseText>
    <BaseText
      v-if="requirementsPerVariation"
      inline
      :href="helpCenterArticleUrl($t('service.resources.different_per_variation_url'))"
    >
      {{ $t('service.resources.different_per_variation_more_info') }}
    </BaseText>
    <RequirementsForm
      v-if="!requirementsPerVariation"
      :variation="formData"
    />
    <Flex
      v-else
      v-test="'requirements-per-variation'"
      direction="column"
    >
      <div
        v-for="(variation, index) in activeVariations"
        :key="index"
        :class="$style.requirementsContainer"
      >
        <BaseHeading icon="layers">
          {{ variation.variationName }}
        </BaseHeading>
        <RequirementsForm
          :variation="variation"
          startCollapsed
        />
      </div>
    </Flex>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { helpCenterArticleUrl } from '@/helpers/help-center';
import type { ServiceVariation, ServiceVariationsFormData } from '../types';
import RequirementsForm from './RequirementsForm.vue';

const formData = inject<ServiceVariationsFormData>('serviceFormData')!;
const requirementsPerVariation = inject<ServiceVariationsFormData>(
  'requirementsPerVariation',
)!;
const activeVariations = inject<ServiceVariation[]>('activeVariations')!;
</script>

<style
  module
  lang="scss"
>
.base {
  display: flex;
  flex-direction: column;
  gap: $spacing;
}

.requirementsContainer {
  display: flex;
  flex-direction: column;
  gap: $spacing;
}
</style>
